import { socialLinksTranslation } from "data/contact/translationContact";
import { useLanguagesContext } from "hooks/useContextAll";
import React from "react";


const SocialLinks = () => {
    const language = useLanguagesContext();

    let socialMediaLinks = [
        { name: "linkedin", link: "https://www.linkedin.com/in/yousef-a-r/" },
        { name: "discord", link: "https://discord.com/users/yozu#2017" },
    ];

    return (
        <div className="social-links-container animate-fade-right">
            <h4>{socialLinksTranslation[language.language]}</h4>
            <ul className="social-links ltr">
                {socialMediaLinks.map((link) => {
                    return (
                        <li key={`social-link-${link.name}`}>
                            <a href={link.link} target="_blank" rel="noreferrer">
                                <ion-icon name={`logo-${link.name}`}></ion-icon>
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default SocialLinks;
